import { AspectFilterRegistryItem } from '../AspectFilterRegistryItem';
import { AspectFilterRegistryCategory } from '../AspectFilterRegistryCategory';
export class AspectFilterGlobal extends AspectFilterRegistryCategory {
    label = 'Global';
    constructor(parent) {
        super(parent);
        super.init();
    }
    rendered = () => new AspectFilterRegistryItem({
        label: 'Nur gerenderte',
        filter: ({ a }) => a.aspectMounts.isAspectMounted,
    });
    outermost = () => new AspectFilterRegistryItem({
        label: 'Äußester gerenderter',
        filter: ({ a }) => a.actor.actorMounted.outermostRenderedAspect === a,
    });
    comments = () => new AspectFilterRegistryItem({
        label: 'comments',
        filter: ({ a }) => a.name.includes('comment'),
    });
    contentAspects = () => new AspectFilterRegistryItem({
        label: 'aspectsWithLocalContent',
        filter: ({ a }) => a.persistentAspect.aspectContent.local.hasContent,
    });
}
